import { render } from "./ScenariosMaker.vue?vue&type=template&id=1879f7bc&scoped=true"
import script from "./ScenariosMaker.vue?vue&type=script&lang=ts"
export * from "./ScenariosMaker.vue?vue&type=script&lang=ts"

import "./ScenariosMaker.vue?vue&type=style&index=0&id=1879f7bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1879f7bc"

export default script